app.directive('numberFormat', ["$filter", function($filter) {
	return {
		restrict: 'AE',
		require: '?ngModel',
		scope: {},
		link: function(scope, elem, attrs, ctrl) {
			ctrl.$formatters.unshift(function (a) {
				return formatNumber(ctrl.$modelValue).fin;
            });

			ctrl.$parsers.unshift(function (viewValue) {
				var cursorPos = elem[0].selectionStart;
				var parsed = formatNumber(viewValue);

				elem.val(parsed.fin);
				elem[0].setSelectionRange(cursorPos, cursorPos);

				return parseFloat(parsed.eng);
            });

            function formatInteger(val) {
            	return val.split('').reverse().join('').replace(/(\d{3})/g, '$1 ').split('').reverse().join('');
            }

			/**
			 * This is shit. Don't know why this has been done like it was! I would think one could just use .toFixed(2)
			 * and format that. BUUUUT unfortunately I don't know how this is used and is val always float etc. So let's
			 * do another ugly piece of shit code for formatting this shit.
			 *
			 * @param val
			 * @returns {{eng: string, fin: string}}
			 */
			function formatNumber(val) {
				var integer = 0;
				var decimals = 0;
				if (val === null || val.toString === undefined) {
					return {
						eng: "0.00",
						fin: "0,00"
					};
				}
				var split = val.toString().split(/[,\.]/);
				if (split[0] !== undefined) {
					// Remove spaces if "formatted" and leading zeros.
					integer = split[0].replace(/[^\d]/g, '').replace(/^0+/, '');
				}
				if (split[1] !== undefined) {
					decimals = split[1] + '0';
					decimals = decimals.substring(0, 2);
				}
				var formattedInteger = formatInteger(integer);

				if (!formattedInteger) {
					formattedInteger = 0;
				}

				if (!decimals) {
					decimals = '00';
				}

				return {
					eng: integer + '.' + decimals,
					fin: formattedInteger + ',' + decimals
				};
            }
		}
	};
}]);
	
